<script setup>
import { Head, useForm, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { ShieldCheck } from 'lucide-vue-next'
import Logo from '../../Components/Logo.vue'
import Field from '../../Components/Admin/Field.vue'

defineOptions({ layout: null })

const page = usePage()
const unit = computed(() => page.props.unit ?? {})
const form = useForm({ email: '', password: '' })
const submit = () => form.post('/admin/entrar', { onFinish: () => form.reset('password') })
</script>

<template>
  <Head title="Administração" />

  <div class="flex min-h-screen items-center justify-center bg-up-navy px-4 py-10 font-sans">
    <div class="w-full max-w-md">
      <div class="mb-8 text-center text-white">
        <Logo class="text-xl" />
        <p class="mt-2 text-xs tracking-[0.18em] text-up-orange uppercase">Área administrativa</p>
      </div>

      <div class="rounded-card bg-white p-6 shadow-card sm:p-8">
        <h1 class="text-lg font-semibold text-up-navy">Acesso da equipe</h1>
        <!-- A unidade aparece antes do login: cada uma é um banco separado. -->
        <p class="mt-1 text-sm text-slate-500">
          Unidade <span class="font-medium text-up-navy">{{ unit.city }}</span>.
          Contas são por unidade e por pessoa.
        </p>

        <p
          v-if="form.errors.login"
          id="erro-login"
          role="alert"
          class="mt-5 rounded-lg bg-up-orange/10 px-4 py-3 text-sm text-up-orange-dark"
        >
          {{ form.errors.login }}
        </p>

        <form class="mt-6 space-y-4" @submit.prevent="submit">
          <Field id="email" v-model="form.email" label="E-mail" type="email" autocomplete="email" required />
          <Field id="password" v-model="form.password" label="Senha" type="password" autocomplete="current-password" required />

          <button
            type="submit"
            :disabled="form.processing"
            class="flex w-full items-center justify-center gap-2 rounded-lg bg-up-orange px-4 py-3.5 text-sm font-semibold tracking-wide text-white uppercase transition-colors hover:bg-up-orange-dark disabled:cursor-not-allowed disabled:opacity-60"
          >
            <ShieldCheck class="h-4 w-4" aria-hidden="true" />
            {{ form.processing ? 'Entrando…' : 'Entrar' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
